// eslint-disable-next-line jira/filename-case
import { useMemo, useState, type Dispatch, type SetStateAction } from 'react';
import {
	MENU_ID_ROADMAPS,
	MENU_ID_ROADMAPS_VIEW_ALL,
} from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { useSidebarNav4 } from '@jira/navigation-apps__sidebar-nav4-context/src/controllers/sidebar-context/index.tsx';

// `useLocalIsExpanded` must take `isExpanded` as an extra argument
// because there is possibility to use `Hide from sidebar` functionality
// and hide `Roadmaps` thus force rendering it without really being
// on any Roadmaps page.
//
// Steps to reproduce
//   1. `Hide from sidebar` for `Roadmaps` menu item.
//   2. Open a JPD Project.
//   3. Ensure that `Roadmaps` menu item is not rendered (for example just refresh the page).
//   2. Click `••• More` and choose `Roadmaps` while still being on a `JPD Project`.
//
// Actions listed above will cause rendering of `Roadmaps` menu item
// while `isInitialSelectedPath` will always return false for any roadmap path
// as redirect "is happening later"
//
// Thankfully, we have access to `isExpanded` prop coming from the parent
// Navigation component.
export function useLocalIsExpanded(
	isExpanded: boolean,
): [boolean, Dispatch<SetStateAction<boolean>>] {
	const { isInitialSelectedPath } = useSidebarNav4();
	const isExpandedByDefault = useMemo(
		() =>
			isInitialSelectedPath(MENU_ID_ROADMAPS) || isInitialSelectedPath(MENU_ID_ROADMAPS_VIEW_ALL),
		[isInitialSelectedPath],
	);

	return useState(isExpandedByDefault || isExpanded);
}
